import { useEffect, useState } from "react";

/** Where the attorney's chosen reviewer name lives between sessions. */
export const REVIEWER_NAME_STORAGE_KEY = "caseblink.docx.reviewer";

export const readReviewerName = (): string => {
  try {
    return window.localStorage.getItem(REVIEWER_NAME_STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
};

export const writeReviewerName = (name: string) => {
  try {
    if (name.trim())
      window.localStorage.setItem(REVIEWER_NAME_STORAGE_KEY, name.trim());
    else window.localStorage.removeItem(REVIEWER_NAME_STORAGE_KEY);
  } catch {
    // Storage disabled: the name lasts for the session only.
  }
};

/**
 * The name written on the attorney's comments and tracked changes: an explicit
 * preference wins, else the signed-in name, else a neutral fallback.
 */
export const useReviewerName = (accountName: string | undefined) => {
  const [preferred, setPreferred] = useState(readReviewerName);
  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key === REVIEWER_NAME_STORAGE_KEY)
        setPreferred(readReviewerName());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);
  const set = (name: string) => {
    writeReviewerName(name);
    setPreferred(name.trim());
  };
  return {
    name: preferred || accountName?.trim() || "CaseBlink",
    preferred,
    accountName: accountName?.trim() || "",
    set
  };
};
